import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';

export const Testimonial = () => {
  return (
    <section className="py-24 bg-[#0F0F13]">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="glass p-10 sm:p-12 rounded-2xl relative"
        >
          <Quote className="absolute top-8 left-8 w-12 h-12 text-[#00E599]/20" />
          
          <blockquote className="relative z-10">
            <p className="text-xl sm:text-2xl font-body text-[#F4F4F5] leading-relaxed mb-8">
              I used to wake up to 10 missed calls every morning. Since starting, the AI has booked <span className="font-bold gradient-text">42 jobs in the last month</span> that I definitely would have lost to the guy down the street.
            </p>
            
            <footer className="flex items-center gap-4 pt-6 border-t border-white/10">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#00E599] to-[#00D4FF] flex items-center justify-center">
                <span className="text-2xl font-headline font-bold text-[#050505]">JR</span>
              </div>
              <div>
                <p className="text-lg font-body font-bold text-[#F4F4F5]">Jim R.</p>
                <p className="text-sm text-[#A1A1AA]">Owner of Precision Air & Heat</p>
              </div>
            </footer>
          </blockquote>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonial;
